export default __webpack_public_path__ + "static/media/canvas-logo-full-black.4e15040a.svg";